/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UoMDimension, UomRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { UomListItem } from './uom-list-item.model';

@Injectable()
export class UomListBusinessService implements InitViewService {

  constructor(private uomRest: UomRestService,
              private gridLayoutService: GridLayoutService,
              private dictionaryService: DictionaryService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('unitsOfMeasures'),
      uomDimensions: this.dictionaryService.getByEnum(UoMDimension),
    };
  }

  findAllAsDataSource(): SlicedDataSource<UomListItem> {
    return this.uomRest.findAllAsDataSource();
  }

  remove(uomItem: UomListItem): Observable<UomListItem> {
    return this.uomRest.remove(uomItem);
  }

  checkUsage(uomItem: UomListItem): Observable<any> {
    return this.uomRest.checkUsage(uomItem);
  }

  bulkDelete(items: any[]): Observable<any> {
    return this.uomRest.bulkDelete(items);
  }

}
